import { AddressType, ContactRoleType, LOBType, LocationType } from "src/app/_common/_enum/module.enum";


export class Renewal {
    selectedStep: string;
    fromReview: boolean = false;
    renewalData: any = new StartRenewal();
}

export class StartRenewal{
    selectedStep: string;           // Not sending to BE.

    // Below data are for SUBMIT renewal api.
    renewalNumber: string;
    account = {
        accountNumber: 0,
        originalName:"",
        requestedName : "",
        changeReason: "",
        other: ""
    };
    address = {
        original: [],               // Collection of LocationObject
        requested: []               // Collection of LocationObject
    }
    //accountAddresses = [];          
    contacts = {
        original: [],               // Collection of ContactObject
        requested: []               // Collection of ContactObject
    };
    renewingPolicies = [];
    
    exposures = []
    diceExposure = new DiceExposure();

    /* selectedOptions = [
        {
            category : "",
            infos: []               // Collection of OptionObject
        }
    ]; */
    comment: string = "";
    quoteNeedByDate = null;
    noQuoteNeeded: boolean = true;
    attachments: [
      {
        documentType: string,
        fileType: string,
        fileName: string,
        contentStream: string
      }
    ]
}

export class ChangeRenewal {
    selectedStep: string;
    fromReview: boolean = false;
    renewalData: any = new ChangeRenewalData();
}

export class ChangeRenewalData extends StartRenewal {
    exposures = [];
}


export class DiceExposure {
    annualGPC = null;
    yearGPC = null;
    mediaTypes = [];
    additionalInfo:string = "";
}


export class RenewalMethods {
    
    newLocationObject(_address: LocationObject) {
        let address = new LocationObject();
        address.addressType = _address.addressType;
        address.careof = _address.careof;
        address.label = _address.label;
        address.addressLine1 = _address.addressLine1;
        address.addressLine2 = _address.addressLine2;
        address.city = _address.city;
        address.state = _address.state;
        address.zip = _address.zip;
        address.country = _address.country;
        address.county = _address.county;
        address.verified = _address.verified || "true";
        if(_address.isEdited != undefined && _address.isEdited != null)
            address.isEdited = _address.isEdited;
        return address;
    }
    
    getFinalRenewalData(_renewal: StartRenewal) {
        let finalRenewalData = {
            renewalNumber: _renewal.renewalNumber,
            account: _renewal.account,
            address: _renewal.address,
            contact: _renewal.contacts,
            diceExposure: _renewal.diceExposure,
            renewingPolicies: _renewal.renewingPolicies,
            exposures: _renewal.exposures,
            comment: _renewal.comment,
            quoteNeedByDate: _renewal.quoteNeedByDate,
            noQuoteNeeded: _renewal.noQuoteNeeded,
            attachments: _renewal.attachments,
        };

        return finalRenewalData;
    }

    
    getFinalRenewalChangeData(_renewal: ChangeRenewalData) {
        let finalRenewalData = {
            renewalNumber: _renewal.renewalNumber,
            account: _renewal.account,
            address: _renewal.address,
            contact: _renewal.contacts,
            diceExposure: _renewal.diceExposure,
            renewingPolicies: _renewal.renewingPolicies,
            exposures: _renewal.exposures,
            comment: _renewal.comment,
            quoteNeedByDate: _renewal.quoteNeedByDate,
            noQuoteNeeded: _renewal.noQuoteNeeded,
            attachments: _renewal.attachments,
        };

        return finalRenewalData;
    }

    resetRenewalForm(_renewal: StartRenewal, _resetRenewingPolicies: boolean = false) {
        if (_resetRenewingPolicies) {
            _renewal.renewingPolicies = [];
        }
        _renewal.exposures = [];
        _renewal.diceExposure = new DiceExposure();
        _renewal.comment = "";
        _renewal.noQuoteNeeded = true;
        _renewal.quoteNeedByDate = null;

        return _renewal;
    }
}

export class LocationObject{
    addressType : string = "";
    careof: string = "";
    label: string = "";
    addressLine1: string = "";
    addressLine2: string = "";
    city: string = "";
    state: string = "";
    zip: string = "";
    country: string = "";
    county: string = "";
    verified: string = "true";
    isEdited: boolean = false;
}
export class BusinessAddress extends LocationObject{
    addressType: string = AddressType.Business;
    label = LocationType.PRIMARY;
}
export class MailingAddress extends LocationObject{
    addressType : string = AddressType.Mailing;
    label = LocationType.MAILING_ADDRESS;
}
export class BillingAddress extends LocationObject{
    addressType : string = AddressType.Billing;
    label = LocationType.BILLING_ADDRESS;
}

/* export class AccountAddress {
    constructor(_addresses) {
        return {addresses: _addresses, isEdited: false };
    }
    addresses: [];          // Collection of LocationObjects
    isEdited: false
}
 */


export class ContactObject {
    firstName: string = ""
    lastName: string = "";
    companyName?: string = "";
    email?: string = "";
    phone?: string = "";
    roleName?: string = "";
    isEdited?: boolean = false;
}
export class AuditContact extends ContactObject{
    super(_contact:ContactObject) {
        return _contact;
    }
    roleName: string = ContactRoleType.Audit;
}
export class BillingContact extends ContactObject{
    super(_contact:ContactObject) {
        return _contact;
    }
    roleName: string = ContactRoleType.Billing;
}



export class OptionObject {
    keyValueID: string;
    shortText: string;
    fullText: string;
    value: string;
    additionalInfos: string;
}